const appID = '5f7b3eb7e197fd4f8b4c70a4';

const init = ({ user, subscription, integrations, cannyFlag, organization }) => {
    // Check if already initialized globally
    if (window.__CANNY_INITIALIZED__) {
        return true;
    }

    // Set flag immediately to prevent race conditions
    window.__CANNY_INITIALIZED__ = true;

    try {
        window.Canny(
            'identify',
            {
                appID: appID,
                user: {
                    email: user.email,
                    name: user.fullName,
                    id: user.id,
                    avatarURL: user.photoUrl,
                    created: new Date(user.createdAt).toISOString(),
                    companies: [
                        {
                            created: new Date(organization.created_at).toISOString(),
                            id: organization.id,
                            name: organization.name,
                        },
                    ],
                    customFields: {
                        role: user.role,
                        company: organization.name,
                        integration: integrations,
                        plan: subscription.plan.name,
                    },
                },
            },
            () => {
                // Initialize changelog (flag already set above)
                try {
                    window.Canny('initChangelog', {
                        appID: appID,
                        position: 'right',
                        align: 'bottom',
                    });
                } catch (error) {
                    console.error('[VUE-APP] Error initializing Canny changelog:', error);
                }
            }
        );

        cannyFlag = true;
    } catch (error) {
        console.error('[VUE-APP] Error during Canny user identification:', error);
        // Reset flag on error to allow retry
        window.__CANNY_INITIALIZED__ = false;
    }

    return cannyFlag;
};

const Canny = {
    init,
};

export default Canny;
